import { MaterialModule } from '../../../material/material.module';
import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';
import HighchartsBoost from 'highcharts/modules/boost';
import { ChartSharedService } from '../../services/chart-shared.service';
import { CommonModule } from '@angular/common';
import { FormattingPipe } from '../../pipes/formatting.pipe';
import { ColorConfigService } from '../../services/color-config.service';
import AccessibilityModule from 'highcharts/modules/accessibility';

AccessibilityModule(Highcharts);
HighchartsMore(Highcharts);
HighchartsNoData(Highcharts);
HighchartsBoost(Highcharts);



@Component({
  selector: 'app-chart-retiro-hoy',
  standalone: true,
  imports: [MaterialModule, CommonModule, FormattingPipe],
  templateUrl: './chart-retiro-hoy.component.html',
  styleUrl: './chart-retiro-hoy.component.less'
})
export class ChartRetiroHoyComponent implements OnInit {
  @Input() title!: string;
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  chartData: { capital: number; ganancia_actual: number }[] = [];
  totalCapital: number = 0;
  totalGanancia: number = 0;
  rentabilidad: number = 0;

  ngOnInit() {

    this.graphService.detalleInversionesData$.subscribe(data => {

      if (data) {
        this.processSimulacionData(data.info.data.investments_dict);
        this.loadChart();
      } else {
        console.error('Datos no válidos o vacíos');
      }
    });
  }

  processSimulacionData(alVencimiento: any) {
    const typedData = alVencimiento as { capital: number; ganancia_actual: number }[];
    if (typedData && typedData.length > 0) {
      this.chartData = typedData.map(item => ({
        capital: item['capital'],
        ganancia_actual: item['ganancia_actual'],
      }));
    
      this.totalCapital = this.chartData.reduce((acc, item) => acc + item.capital, 0);
      this.totalGanancia = this.chartData.reduce((acc, item) => acc + item.ganancia_actual, 0);
    
      this.rentabilidad = this.totalCapital ? (this.totalGanancia / this.totalCapital) * 100 : 0;

    } else {
      console.error('Datos no válidos o vacíos');
    }
  }
  

  constructor(
    private graphService: ChartSharedService,
    private colorConfigService: ColorConfigService,
  ) {}

  loadChart() {
    const rentabilidadData = [{
      name: 'Rentabilidad',
      y: this.rentabilidad,
    }];
  
    const totalGananciaData = [{
      name: 'Total Ganancia',
      y: this.totalGanancia,
    }];

    this.chartOptions = {
      colors: this.colorConfigService.getColors(),
      chart: {
        type: 'bar',
        backgroundColor: 'white',
        style: {
          fontFamily: 'DM Sans',
        },
      },
      credits: {
        enabled: false
      },
      title: {
        text: '',
        align: 'left',
      },
      xAxis: {
        visible: false,
      },
      yAxis: [{
        visible: false,
        title: {
          text: 'Ganancia'
        }
      }, {
        visible: false,
        title: {
          text: 'Rentabilidad'
        },
        opposite: true,
        max: 10,
      }],
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        itemMarginBottom: 5,
        itemStyle: {
          lineHeight: '14px',
        },
      },
      tooltip: {
        headerFormat: '',
        pointFormatter: function (this: any) {
          if (this.series.name === 'Rentabilidad') {
            return `<span style="color:${this.series.color}"><b>${this.series.name} hoy:</span> ${Highcharts.numberFormat(this.y, 2)}%</b>`;
          } else {
            return `<span style="color:${this.series.color}"><b>${this.series.name} hoy:</span> $${Highcharts.numberFormat(this.y, 0, ',', '.')}</b>`;
          }
        }
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            formatter: function (this: any) {
              if (this.series.name === 'Rentabilidad') {
                return Highcharts.numberFormat(this.y, 2) + '%';
              } else {
                return '$' + Highcharts.numberFormat(this.y, 0, ',', '.');
              }
            },
          },
          groupPadding: 0.3,
        },
      },
      series: [
        {
          type: 'bar',
          name: 'Ganancia',
          data: totalGananciaData,
        } as unknown as Highcharts.SeriesBarOptions,
        {
          type: 'bar',
          name: 'Rentabilidad',
          data: rentabilidadData,
        } as unknown as Highcharts.SeriesBarOptions,
      ],
    };

    if (document.getElementById('container-retiro-hoy')) {
      Highcharts.chart('container-retiro-hoy', this.chartOptions);
    } else {
      console.log('Chart container not found');
    }


  }

}
